export const C = {
  bg: '#F5F0E8',
  orange: '#C4601D',
  card: '#fff',
  border: '#E8E0D0',
  greenDark: '#3B6D11',
  green: '#5A8A2E',
  greenLight: '#F0F7E8',
  greenTileBg: '#EAF3DE',
  greenTileBorder: '#C8DFA0',
  red: '#8B2500',
  redLight: '#FEF0EE',
  redRow: '#FEF6F3',
  redBorder: '#F5C4B3',
  amber: '#8B4513',
  amberLight: '#FDF3EC',
  amberBorder: '#F0C9A8',
  blue: '#1A5EA8',
  textDark: '#2C2420',
  textMuted: '#6B5F55',
  textFaint: '#9A8F82',
  logoX: '#EDA877',
};

export const RADIUS = { lg: 16, md: 10 };

// ─── page heading ───────────────────────────────────────────────────────────
// Every screen names itself the same way: the title and its one-line subtitle,
// centred over the content beneath them.
//
// `textAlign: 'center'` sits on the TITLE AND SUBTITLE ELEMENTS THEMSELVES, not on
// a wrapper. Centring the container (`margin: 0 auto`) only moves the box; a
// full-width box still leaves its text hard against the left edge, which is what
// three earlier attempts at this actually shipped. Spread these objects onto the
// heading elements so the rule cannot drift page by page.
/** @type {import('react').CSSProperties} */
export const PAGE_TITLE = {
  fontSize: 26,
  fontWeight: 500,
  color: C.textDark,
  textAlign: 'center',
  marginBottom: 4,
};

/** @type {import('react').CSSProperties} */
export const PAGE_SUB = {
  fontSize: 14,
  color: C.textMuted,
  textAlign: 'center',
  marginBottom: 22,
  lineHeight: 1.5,
};

export const FONT_SANS =
  "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif";
